import { render, staticRenderFns } from "./SubmitArea.html?vue&type=template&id=06569f14&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitArea.scss?vue&type=style&index=0&id=06569f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06569f14",
  null
  
)

export default component.exports